const Group = {
  state: {
    group_verify_count: 0,
  },
  getters: {
    group_verify_count: (state) => state.group_verify_count,
  },
  mutations: {
    SET_GROUP_VERIFY_COUNT(state, val) {
      state.group_verify_count = val;
    },
  },
};
export default Group;
